import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const ContainerTextTitle = styled.div`
  text-align: center;
  padding: 60px 0 30px 0;
  font-family: 'Inter', sans-serif;
  font-size: 32px;
  strong {
    font-weight: bold;
  }
  @media (max-width: 425px) {
    padding: 10px 0 30px 0;

    p {
      font-size: 18px;
    }
  }
`;
export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  ${handleQuery(css`
    padding: 0 1em;
    margin-bottom: 2em;
  `)}
`;

export const Content = styled.div`
  width: 1258px;
  //max-width: 1120px;

  // Desktop padrão (1200px - 1439px)
  @media (min-width: 1200px) and (max-width: 1439.98px) {
    width: 1100px;
  }

  // Desktop pequeno (992px - 1199px)
  @media (min-width: 992px) and (max-width: 1199.98px) {
    width: 950px;
  }

  // Tablet landscape (768px - 991px)
  @media (min-width: 768px) and (max-width: 991.98px) {
    width: 800px;
  }

  // Tablet portrait (576px - 767px)
  @media (max-width: 767.98px) {
    width: 100%;
    max-width: 540px;
    padding: 0 16px;
  }

  ${handleQuery(css`
    width: 100%;
  `)}
`;

export const Item = styled.div`
  display: flex;

  ${({ align }) =>
    css`
      justify-content: ${align};
      @media (min-width: 768px) and (max-width: 991.98px) {
        justify-content: center;
        width: 800px;
      }
    `}
`;

export const Box = styled.div`
  display: flex;
`;

export const ContainerText = styled.div`
  ${({ bgColor }) =>
    css`
      background-color: ${bgColor};
    `}

  width: 654px;
  @media (min-width: 768px) and (max-width: 991.98px) {
    width: 404px;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContentText = styled.div`
  width: 80%;
  display: grid;
  gap: 8px;
`;

export const ContainerImg = styled.div`
  width: 302px;
  @media (min-width: 768px) and (max-width: 991.98px) {
    width: 250px;
  }
`;

export const Title = styled.h4`
  font-size: 1.3em;
  font-weight: bold;
  font-family: 'Inter', sans-serif;

  ${({ color }) =>
    css`
      color: ${color};
    `}

  ${handleQuery(css`
    margin-bottom: 1em;
  `)}
`;

export const Desc = styled.p`
  font-size: 1em;
  font-family: 'Inter', sans-serif;

  ${({ color }) =>
    css`
      color: ${color};
    `}

  ${handleQuery(css`
    font-size: 1.2em;
    line-height: 25px;
  `)}
`;

export const ResponsiveContainer = styled.p`
  display: flex;
  flex-direction: column;
`;

export const ResponsiveContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerTextResponsive = styled.div`
  ${({ bgColor }) =>
    css`
      background-color: ${bgColor};
    `}

  padding: 2em;
  margin-top: -2px;
`;
